import { configureStore } from "@reduxjs/toolkit";
import AdminSlice from "../FunctionComponents/Redux/AdminSlice";

export default configureStore({
 reducer: {
  admin: AdminSlice,
 },
});
